import HomeCard from "../HomeCard";
import "./HomeCard2.css";

const HomeCard2 = () => {
    return <HomeCard className={"home-card-2"} itemType={"gather"} itemKey={1} itemName="서울 ICT 이노베이션 스퀘어" itemDesc="더 많은 연결과 소통을 향한 메타버스"/>
};

export default HomeCard2;
